import React from 'react';

const TESTIMONIALS = [
  {
    id: 1,
    name: "Manoj T.",
    initials: "MT",
    location: "India",
    text: "Saved over $1500 buying Quantum Athena here instead of MQL5. Same exact EA, same performance. Algo Forex EA is a no-brainer for serious traders.",
    colorClass: "bg-primary/20 text-primary"
  },
  {
    id: 2,
    name: "Sneha K.",
    initials: "SK",
    location: "UAE",
    text: "The backtest data they provide is incredibly detailed—monthly returns, drawdown charts, profit factors. It's the transparency that made me trust this platform.",
    colorClass: "bg-secondary/20 text-secondary"
  },
  {
    id: 3,
    name: "Amit R.",
    initials: "AR",
    location: "Singapore",
    text: "I couldn't find a specific EA on their marketplace, so I used the custom request feature. They had it listed within 48 hours at 70% off. Incredible service.",
    colorClass: "bg-surface-tint/20 text-surface-tint"
  }
];

const TestimonialsSection = () => {
  return (
    <section className="py-24 max-w-container-max mx-auto px-margin-mobile md:px-margin-desktop reveal-on-scroll">
      <div className="text-center mb-16">
        <h2 className="font-headline-md text-headline-md mb-4">What Traders <span className="text-primary">Are Saying</span></h2>
        <p className="text-on-surface-variant">Join thousands of traders who trust Algo Forex EA for premium Expert Advisors.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-gutter-desktop">
        {TESTIMONIALS.map((testimonial) => {
          // Mostly 5 stars, sometimes 4
          const starsCount = Math.random() > 0.8 ? 4 : 5;
          return (
            <div key={testimonial.id} className="glass-card p-8 rounded-2xl flex flex-col stagger-item">
              <div className="flex text-primary mb-6">
                {[1, 2, 3, 4, 5].map(star => (
                  <span key={star} className="material-symbols-outlined" style={{ fontVariationSettings: star <= starsCount ? "'FILL' 1" : "'FILL' 0" }}>
                    star
                  </span>
                ))}
              </div>
              <p className="text-on-surface-variant mb-10 italic flex-grow">"{testimonial.text}"</p>
              <div className="flex items-center space-x-4 border-t border-white/5 pt-6">
                <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold ${testimonial.colorClass}`}>
                  {testimonial.initials}
                </div>
                <div>
                  <div className="font-bold text-silver-text">{testimonial.name}</div>
                  <div className="text-[12px] text-on-surface-variant">Verified Buyer · {testimonial.location}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TestimonialsSection;
